<template>
    <div>
      <HeaderPage href="/institution"/>
      <div class="neiBanner">
          <div class="textBanner wow" data-animate="fadeInUp">
              <dl>国正安全技术</dl>
              <dt>正念 / 正心 / 正言 / 正行</dt>
          </div>
      </div>
      <div>
        <div class="about wow" data-animate="fadeInRight">
          <div class="wrap">
            <div class="ntitle">
              <h3>INSTITUTIONAL PROFILE</h3>
              <h2>机构简介</h2>
            </div>
            <div class="text">
                浙江国正集团总部位于绍兴市柯桥区金柯桥大道1358号国贸大厦17-20楼，总面积6000平方米。是一家以安全评价、职业卫生检测与评价，环境保护检测、安全生产检测检验、企业咨询管理、专利代理、科技项目服务、科技成果转化为主体的综合类高新技术企业，具有独立的法人资格，服务大企业超5000家。，拥有健全的内部管理制度和保密制度，现有建材、化工、机械、电气、消防、矿山、冶金、仪表、土木、职业卫生、安全等专业的技术人员85人。
                <br/><br/>公司是经浙江省应急管理厅批准的安全评价机构，证书编号为APJ-(浙)-007。
                <br/><br/>是经浙江省生态环境厅、绍兴市生态环境局认可的社会环境检测机构。
                <br/><br/>是经浙江省卫生健康委员会批准的职业卫生技术服务机构，证书编号为浙（08）卫职技字（2016）第002号通过计量认证检测项目千余项。
                <br/><br/>公司现有人员熟悉企业管理工作流程，具有丰富的企业安全管理技术和工作经验，以其规范、科学、严谨的工作态度为客户提供务实、高效的安全生产技术服务。
                <br/><br/>浙江国正安全技术有限公司是一家受社会尊敬、让员工自豪、新时代一流的高新技术企业。
            </div>
          </div>
           
        </div>
      </div>
      <FooterPage />
    </div>
  </template>
    
  <script setup>
  import { onMounted, onUnmounted } from 'vue'
  // 组件逻辑
  import HeaderPage from '@/components/HeaderPage.vue'
  import FooterPage from '@/components/FooterPage.vue'
  import '@/assets/css/animate.min.css'
  

  let intervalId


  const stopAutoScroll = () => {
    clearInterval(intervalId)
  }

  onMounted(() => {

    // ✅ 滚动动画逻辑
    const elements = document.querySelectorAll('.wow')
    const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
    elements.forEach((el) => observer.observe(el))
    onUnmounted(() => {
      elements.forEach((el) => observer.unobserve(el))
      stopAutoScroll()
    })
  })
  </script>
  
  <style scoped>
  .neiBanner {
      height: 640px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      background:url('@/assets/about.jpg');
  }
  .neiBanner .textBanner {
    color: #fff;
    text-align: center;
    font-weight: bold;
  }
  .neiBanner .textBanner dl {
    font-size: 72px;
  }
  .neiBanner .textBanner dt {
    font-size: 30px;
    font-weight: 500;
  }
  .about {
    padding: 65px 0 70px;
  }
  .about .wrap {
    width: 1680px;
    margin: 0 auto;
  }
  .about .ntitle h3 {
    font-size: 36px;
    line-height: 1;
    color: #003366;
    font-weight: 500;
    border-bottom: #003366 solid 1px;
    display: inline-block;
    padding: 0 0 15px;
    margin-bottom: 15px;
  }
  .about .ntitle h2 {
    font-size: 30px;
    line-height: 1;
    color: #333;
    font-weight: 500;
  }
  .about .text {
    padding: 60px 0;
    line-height: 1.8;
    color: #666;
    font-size: 18px;
  }
  .about .text  p {
    line-height:30px;
  }
  </style>